module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.1f0cb00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/climasense/picudo_agave/curativa/malphos_1000ce.png
// module id = 1034
// module chunks = 3